import type { GridApiPremium } from '@mui/x-data-grid-premium';
import { gridRowSelectionIdsSelector, useGridSelector } from '@mui/x-data-grid-premium';

import { getDocumentIdsFromGridRows } from './data-grid-premium';

/**
 * The documents among the selected rows. A selected group header is not one:
 * an action offered on the strength of this list would point at the column
 * the group is keyed on, which for an extraction question is the question's
 * own id. See `getDocumentIdFromGridRow`.
 */
export function useSelectedDocumentIds(apiRef: React.RefObject<GridApiPremium | null>) {
  // @ts-expect-error MUI v9: useGridApiRef returns RefObject<X | null> but useGridSelector's parameter type is RefObject<X> (non-null inner). Safe in practice because this hook only runs once the grid has mounted and apiRef.current is non-null.
  const selectionModel = useGridSelector(apiRef, gridRowSelectionIdsSelector);
  const selectedRowIds = Array.from(selectionModel.keys()).map(id => String(id));
  const selectedDocumentIds = getDocumentIdsFromGridRows([...selectionModel.keys()], id =>
    selectionModel.get(id)
  );

  return { selectedDocumentIds, selectedRowIds };
}
